export const parseJwt = (token: string) => {
    try {
        const parts = token.split('.');
        if (parts.length !== 3) {
            throw new Error('Invalid JWT structure');
        }

        const base64Url = parts[1];
        const base64 = base64Url
            .replace(/-/g, '+')
            .replace(/_/g, '/')
            .padEnd(base64Url.length + (4 - (base64Url.length % 4)) % 4, '=');

        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) =>
                    '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2),
                )
                .join(''),
        );

        return JSON.parse(jsonPayload);
    } catch (err) {
        console.error('Failed to parse JWT:', err);
        return null;
    }
};